import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useOrganization } from '@/hooks/useOrganization';

export const Route = createFileRoute('/_authenticated/org/$orgId')({
  component: OrganizationLayout,
});

function OrganizationLayout() {
  const { orgId } = Route.useParams();
  const { organization, isLoading, error } = useOrganization(orgId);

  if (isLoading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
        <p className="text-gray-600 mt-4">Loading organization...</p>
      </div>
    );
  }

  if (error || !organization) {
    return (
      <div className="text-center py-12">
        <div className="text-red-600 mb-4">
          <h2 className="text-2xl font-bold">Organization Not Found</h2>
          <p className="mt-2">{error || 'The organization you are looking for does not exist or you do not have access.'}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Outlet />
    </div>
  );
}